import axios from "axios";
import VueAxios from "vue-axios";
export default {
  install(Vue) {
    axios.defaults.baseURL = process.env.VUE_APP_SERVER_BASE_URL;
    axios.defaults.withCredentials = true;
    Vue.use(VueAxios, axios);
  },
};
